import { useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import "./SidebarUnified.css"; 
import BaknayLogo from "../../common/brand/BaknayLogo";

const isBelowLg = () => window.matchMedia("(max-width: 991.98px)").matches;

export default function SidebarUnified({
  menuOpen,
  setMenuOpen,
  tabs = [],
  basePath = "",
  getActivePath,
  onTabNavigate,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const activeSlug = useMemo(() => {
    if (getActivePath) return getActivePath(location.pathname);
    return location.pathname.split("/").pop();
  }, [location.pathname, getActivePath]);

  const belowLg = typeof window !== "undefined" ? isBelowLg() : false;
  const toggleMenu = () => setMenuOpen((v) => !v);
  const isMini = !menuOpen && !belowLg;
  const asideClasses = ["sidebar"];
  if (menuOpen) {
    asideClasses.push("open");
  } else if (!belowLg) {
    asideClasses.push("mini");
  }
  const asideClassName = asideClasses.join(" ").trim();

  const navigateDefault = (tab) => {
    const to = tab.path ? `${basePath}/${tab.path}` : basePath || "/";
    navigate(to);
  };

  const handleTabClick = (tab) => {
    if (onTabNavigate) onTabNavigate(tab, navigateDefault);
    else navigateDefault(tab);
    if (isBelowLg()) setMenuOpen(false);
  };

  return (
    <div className="sidebar-wrapper">
      {menuOpen && belowLg && (
        <div
          className="sidebar-overlay"
          aria-label="Close menu backdrop"
          onClick={() => setMenuOpen(false)}
        />
      )}

      <aside className={asideClassName}>
        <div className="sidebar-top d-lg-none">
          <Link
            to={basePath || "/home"}
            className="sidebar-brand-mobile"
            onClick={() => setMenuOpen(false)}
            aria-label="Baknay home"
          >
            <BaknayLogo size="sm" />
          </Link>
        </div>
        <ul className="list-unstyled">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const active = activeSlug === tab.path;
            return (
              <li
                key={tab.key}
                className={`sidebar-item ${active ? "active" : ""}`}
                onClick={() => handleTabClick(tab)}
                title={isMini ? tab.label : undefined}
                aria-label={tab.label}
              >
                <span className="item-icon">{Icon ? <Icon size={22} /> : null}</span>
                <span className="item-label text-truncate flex-grow-1">
                  {tab.label}
                </span>
              </li>
            );
          })}
        </ul>

        <div className="sidebar-footer d-none d-lg-block overflow-hidden">
          <button
            type="button"
            className="collapse-cta"
            onClick={toggleMenu}
            aria-label={menuOpen ? "Collapse sidebar" : "Expand sidebar"}
            aria-pressed={menuOpen}
          >
            <span className="chev" aria-hidden="true">
              {menuOpen ? <MdChevronLeft size={20} /> : <MdChevronRight size={20} />}
            </span>
            <span className="item-label text-truncate flex-grow-1">Collapse Menu</span>
          </button>
        </div>
      </aside>
    </div>
  );
}
